import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters('enums', ['getAnswer']),
  },
  methods: {
    enums(from = null, where = null, is = null, select = null) {
      const clause = {
        from,
        where,
        select,
        is,
      }
      return (this.getAnswer(clause))
    },
    ...mapMutations('enums', ['query']),
    back() {
      window.history.back()
    },
  },
}
